import Vue from 'vue';
import VueRouter from 'vue-router';
import getMetaRoute from '@/utils/getMetaRoute';

import BasketPage from '@/BasketPage';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/personal/cart',
      component: BasketPage,
      name: 'basket-page',
      meta: getMetaRoute({
        ddmCategory: 'Cart',
        ddmType: 'cart',
      }),
    },
  ],
});

export default router;

